import { Captcha } from '@apia/components';
import { useField, useFieldStatesClassNames } from '../hooks';
import { FieldWrapper } from './FieldWrapper';
import { TDefaultFieldType } from './types';
import React from 'react';

type TCaptchaProps = {
  name: string;
  imageUrl: string;
  className?: string;
};

type TCaptcha = TCaptchaProps &
  Omit<
    TDefaultFieldType,
    'validationFunction' | 'validationRules' | 'validationClass'
  >;

const InnerCaptcha = ({
  className,
  name,
  imageUrl,
  /**
   * useField
   */
  avoidRegisterIfExists,
  avoidSemicolon,
  formName,
  label,
  removeOnUnmount,
  submitName,
  submitValueParser,
  validationValueParser,
}: TCaptcha) => {
  const { error, updateValidations, onChange, isTouched, ...validationProps } =
    useField({
      name,
      avoidRegisterIfExists,
      formName,
      initialValue: '',
      removeOnUnmount,
      submitName,
      submitValueParser,
      validationValueParser,
      validationRules: { required: true },
    });
  const handleOnChange = React.useCallback(
    (ev: string | React.ChangeEvent<HTMLInputElement>) => {
      onChange(ev);
    },
    [onChange],
  );

  const stateClassName = useFieldStatesClassNames(name);
  return (
    <FieldWrapper
      name={name}
      label={label}
      className={`input ${className ?? ''}`}
      avoidSemicolon={avoidSemicolon}
    >
      <Captcha
        name={name}
        imageUrl={imageUrl}
        onChange={handleOnChange}
        value={validationProps.value}
        className={stateClassName}
      />
    </FieldWrapper>
  );
};

export { InnerCaptcha as Captcha };
